// oklch palette generated with huetone
// colors limited to sRGB colorspace
// https://huetone.ardov.me/?palette=N4IgdghgtgpiBcIDOALArgFwwGxgJwHsBjAaxABoR0YkEBtUSWBEAcTwgE8KQiDsCeWvDogAxADMAnNOk9JAJglKF8mAFYNG%2BQBMpevfKLGT8gEYKLF%2BVNt35AdglOn8gGwfP8gCxFfv%2BQBmAA4QkPkFKUjI%2BQBGGHj4uPVYlPV5AAYJLKyQAF0AX3JGaDhEACUYHR4%2BASF6cQkmpzd5JqqYIjaJHTMdYO6iCCJWykkJMwczDO7gomDvbvU3dUC1KVidBTgxoliMjKSxqUCD2MWxt2yDrrH1bwOMhx99g4vxU8fVMYU3L-yiiVmIgAIJQMz4Gr8QTCUTjCTBbLdGA9HaNHoTMzdHQZKQDMZNCFuNGSQL6A66WLBBwUsYQZyPeTBHTqKS08RuMzeBTssTqDKfGZjQJEBSfCI6WJsoXiBSxeW8qUZIgUwrFcClFjsGAwMBQuqwxreCRECTvMQwK7BGD48REMwSTYysQQHQwMyTGzbMkSeTqMxEGAOc1Syb8zK4iCBX1jA5TQKxCPqLZrWMZbwpW1iA6BBPOg6-DIQCOxFWjcRnfmLNVAsogAAqMAg2H1MIakiypuLYzdslT4jM9MCNqZbqqMfEyctWwjgbMUgjZilE%2BzuO8wXSaYcHgXadZxoj3MC3YrAtilgjCm8sRXZyXzzT53lAPVTDrACFsGg0bU2yJGuoEj0iuTYSNGK46N4QZNOYPSmiuEDMlkK4OFMVwrsOUgOreTwSDAu6nh4fSHkQbKZLEIRuLcp6ROo3ynvE0YlnROFZAo6Q1hqwIgAACmgeAAA64K29T-pI9KIiuYEojBYxBjAyG6EQWyyeIkp7KpYgejImkQG4UyacymjaGMwbXiMfoWEWD7iN4fwZMEJ5iIEDwZG4BFiAoNIZCkcQ4gKK6pDmqicW%2BLAAGoAJb8DAGAiYakimoiJLODqJptAovSaVUQzZZyTgQYhOiacp6jweYbjbO6NjeUQNliA4nx4n69mNT4jzqPVebpv2nn8gKIYqhkCgDKFmqIDxkVgGQlC-qJcJNM4CLIqazpNDoEAJIM%2Bi9YS-izA4EDmk0vgbmowQHG4Tkegc9xMtcTGXEN2x%2Bq8cpBNcVJBI8%2BwRP1GRYoUeSUBgBBgDQDQ8jw4aUK8PBBTwPIyuKlCudD7L2Tw3k8BdMrSjwUgwyAeJ42RhRAA

// TODO: Use oklch raw color values instead of HEX
// when Figma adds support for oklch

export const sr25Gray = Object.freeze({
  0: "#FFFFFF", // oklch(98.21% 0 0)
  20: "#F9F9F9", // oklch(98.21% 0 0)
  50: "#F2F2F2", // oklch(96.12% 0 0)
  100: "#E5E5E5", // oklch(92.19% 0 0)
  150: "#D9D9D9", // oklch(88.53% 0 0)
  200: "#CCCCCC", // oklch(84.52% 0 0)
  300: "#B2B2B2", // oklch(76.36% 0 0)
  400: "#999999", // oklch(68.30% 0 0)
  500: "#7F7F7F", // oklch(59.65% 0 0)
  600: "#666666", // oklch(51.03% 0 0)
  700: "#4C4C4C", // oklch(41.65% 0 0)
  800: "#383838", // oklch(34.07% 0 0)
  850: "#303030", // oklch(31.08% 0 0)
  900: "#292929", // oklch(28.09% 0 0)
  950: "#262626", // oklch(26.86% 0 0)
  980: "#1B1B1B", // oklch(22.21% 0 0)
  990: "#111111", // oklch(17.76% 0 0)
});

export const sr25Red = Object.freeze({
  20: "#FFF7F6", // oklch(98.20% 0.009 26.02)
  50: "#FFEDEC", // oklch(96.01% 0.020 21.36)
  100: "#FFDBD8", // oklch(92.07% 0.040 23.55)
  150: "#FFCAC6", // oklch(88.45% 0.061 23.37)
  200: "#FFB7B0", // oklch(84.48% 0.085 25.25)
  300: "#FF8C84", // oklch(76.33% 0.141 25.05)
  400: "#FF5653", // oklch(68.30% 0.206 25.29)
  500: "#E91D2E", // oklch(59.70% 0.230 25.06)
  600: "#C1001E", // oklch(51.08% 0.207 25.02)
  700: "#930014", // oklch(41.78% 0.169 25.08)
  800: "#6F000C", // oklch(34.12% 0.138 25.22)
  900: "#540007", // oklch(28.09% 0.114 25.09)
  950: "#410004", // oklch(23.64% 0.096 25.25)
  980: "#300002", // oklch(19.47% 0.079 25.65)
  990: "#260002", // oklch(16.94% 0.068 23.90)
});

export const sr25Amber = Object.freeze({
  20: "#FFF8F0", // oklch(98.24% 0.013 71.33)
  50: "#FFEFDE", // oklch(96.03% 0.028 69.17)
  100: "#FFDFBB", // oklch(92.12% 0.059 70.29)
  150: "#FFD098", // oklch(88.56% 0.089 71.17)
  200: "#FFBE6E", // oklch(84.52% 0.123 70.58)
  300: "#F39D00", // oklch(76.42% 0.165 70.66)
  400: "#D18700", // oklch(68.34% 0.147 71.05)
  500: "#AF7000", // oklch(59.81% 0.129 70.84)
  600: "#8D5900", // oklch(50.98% 0.110 70.55)
  700: "#6B4200", // oklch(41.73% 0.090 70.08)
  800: "#503000", // oklch(34.07% 0.074 69.86)
  900: "#3C2300", // oklch(28.18% 0.061 70.23)
  950: "#2D1900", // oklch(23.50% 0.051 70.07)
  980: "#211100", // oklch(19.57% 0.042 69.88)
  990: "#190C00", // oklch(16.93% 0.036 70.87)
});

export const sr25Green = Object.freeze({
  20: "#F4FCF4", // oklch(98.29% 0.013 145.47)
  50: "#E6F8E8", // oklch(96.15% 0.028 148.61)
  100: "#CBF1D0", // oklch(92.22% 0.059 148.80)
  150: "#ADEBB7", // oklch(88.53% 0.095 148.85)
  200: "#92E39F", // oklch(84.62% 0.123 148.40)
  300: "#5BCE74", // oklch(76.32% 0.165 148.38)
  400: "#19B750", // oklch(68.24% 0.189 148.51)
  500: "#009A3F", // oklch(59.88% 0.171 148.51)
  600: "#007B31", // oklch(50.87% 0.145 148.56)
  700: "#005D23", // oklch(41.74% 0.119 148.50)
  800: "#004518", // oklch(34.07% 0.097 148.49)
  900: "#003310", // oklch(28.02% 0.080 148.62)
  950: "#00260A", // oklch(23.44% 0.067 148.62)
  980: "#001C06", // oklch(19.76% 0.056 148.63)
  990: "#001504", // oklch(17.09% 0.048 148.85)
});

export const sr25Teal = Object.freeze({
  20: "#F0FCFA", // oklch(98.16% 0.013 185.10)
  50: "#DEF9F3", // oklch(96.09% 0.029 180.83)
  100: "#BAF3E8", // oklch(92.22% 0.060 181.78)
  150: "#8DEEDF", // oklch(88.53% 0.095 183.03)
  200: "#5DE6D2", // oklch(84.45% 0.122 182.05)
  300: "#00CEB9", // oklch(76.40% 0.137 182.11)
  400: "#00B19F", // oklch(68.24% 0.122 182.26)
  500: "#009485", // oklch(59.82% 0.107 182.47)
  600: "#007669", // oklch(50.76% 0.091 181.73)
  700: "#00594F", // oklch(41.63% 0.075 181.91)
  800: "#00423A", // oklch(34.00% 0.061 181.54)
  900: "#00312B", // oklch(28.10% 0.050 182.14)
  950: "#00241F", // oklch(23.35% 0.042 181.54)
  980: "#001B17", // oklch(19.93% 0.036 181.85)
  990: "#001411", // oklch(17.17% 0.031 183.03)
});

export const sr25Blue = Object.freeze({
  20: "#F5FAFF", // oklch(98.28% 0.009 247.91)
  50: "#EAF3FF", // oklch(96.09% 0.019 255.53)
  100: "#D4E7FF", // oklch(92.13% 0.039 254.29)
  150: "#BFDCFF", // oklch(88.47% 0.058 253.27)
  200: "#A8D0FF", // oklch(84.53% 0.079 252.77)
  300: "#77B6FF", // oklch(76.33% 0.124 252.99)
  400: "#3E9BFF", // oklch(68.27% 0.171 253.07)
  500: "#007FE9", // oklch(59.75% 0.185 253.10)
  600: "#0066BD", // oklch(51.10% 0.158 253.05)
  700: "#004C90", // oklch(41.75% 0.130 253.19)
  800: "#01386C", // oklch(34.10% 0.104 253.10)
  900: "#002952", // oklch(28.11% 0.087 252.93)
  950: "#001E3F", // oklch(23.53% 0.073 253.05)
  980: "#00152F", // oklch(19.58% 0.060 252.86)
  990: "#000F25", // oklch(16.89% 0.052 253.26)
});

export const sr25Purple = Object.freeze({
  20: "#FAF8FF", // oklch(98.26% 0.009 299.24)
  50: "#F3EFFF", // oklch(95.99% 0.022 297.42)
  100: "#E7E0FF", // oklch(92.17% 0.042 295.90)
  150: "#DCD2FF", // oklch(88.62% 0.062 295.29)
  200: "#D1C1FF", // oklch(84.51% 0.087 296.33)
  300: "#BB9FFF", // oklch(76.42% 0.137 296.44)
  400: "#A67BFF", // oklch(68.41% 0.189 296.05)
  500: "#8D5EE5", // oklch(59.85% 0.196 295.97)
  600: "#7441C6", // oklch(50.92% 0.196 296.34)
  700: "#5B20A7", // oklch(41.69% 0.196 296.43)
  800: "#46008A", // oklch(34.07% 0.186 296.11)
  900: "#340069", // oklch(28.05% 0.153 296.28)
  950: "#270051", // oklch(23.47% 0.128 296.57)
  980: "#1D003F", // oklch(19.85% 0.108 296.62)
  990: "#150032", // oklch(17.01% 0.093 295.61)
});

export const sr25Violet = Object.freeze({
  20: "#FCF8FE", // oklch(98.39% 0.009 314.78)
  50: "#F7EEFC", // oklch(96.02% 0.021 313.83)
  100: "#F2DBFF", // oklch(92.10% 0.054 313.46)
  150: "#EDCAFF", // oklch(88.54% 0.081 314.13)
  200: "#E6B7FF", // oklch(84.51% 0.110 313.61)
  300: "#DA8DFF", // oklch(76.38% 0.175 313.99)
  400: "#CD5CFF", // oklch(68.30% 0.242 313.78)
  500: "#B62EEB", // oklch(59.87% 0.266 313.77)
  600: "#9700C7", // oklch(50.94% 0.252 313.86)
  700: "#730098", // oklch(41.79% 0.207 314.03)
  800: "#560073", // oklch(34.12% 0.169 313.90)
  900: "#400057", // oklch(28.00% 0.139 313.69)
  950: "#310043", // oklch(23.55% 0.117 314.08)
  980: "#250034", // oklch(19.93% 0.099 313.72)
  990: "#1C0028", // oklch(17.03% 0.084 314.09)
});

export const sr25Pink = Object.freeze({
  20: "#FFF7F8", // oklch(98.26% 0.009 8.54)
  50: "#FFECF0", // oklch(95.93% 0.021 3.08)
  100: "#FFDAE1", // oklch(92.12% 0.042 5.11)
  150: "#FFC9D3", // oklch(88.61% 0.063 6.02)
  200: "#FFB4C4", // oklch(84.47% 0.089 5.11)
  300: "#FF87A4", // oklch(76.34% 0.148 5.82)
  400: "#FF4C85", // oklch(68.33% 0.217 5.87)
  500: "#E8006A", // oklch(59.81% 0.240 5.83)
  600: "#BB0054", // oklch(50.88% 0.204 5.85)
  700: "#8F003F", // oklch(41.77% 0.168 5.61)
  800: "#6C002E", // oklch(34.14% 0.137 5.50)
  900: "#510021", // oklch(27.96% 0.112 5.25)
  950: "#3F0018", // oklch(23.64% 0.095 5.35)
  980: "#300010", // oklch(19.85% 0.080 6.15)
  990: "#25000B", // oklch(17.00% 0.068 5.62)
});

// OKLCH variants
export const sr25GrayOklch = Object.freeze({
  0: "98.21% 0 0", // #FFFFFF
  20: "98.21% 0 0", // #F9F9F9
  50: "96.12% 0 0", // #F2F2F2
  100: "92.19% 0 0", // #E5E5E5
  150: "88.53% 0 0", // #D9D9D9
  200: "84.52% 0 0", // #CCCCCC
  300: "76.36% 0 0", // #B2B2B2
  400: "68.30% 0 0", // #999999
  500: "59.65% 0 0", // #7F7F7F
  600: "51.03% 0 0", // #666666
  700: "41.65% 0 0", // #4C4C4C
  800: "34.07% 0 0", // #383838
  850: "31.08% 0 0", // #303030
  900: "28.09% 0 0", // #292929
  950: "26.86% 0 0", // #262626
  980: "22.21% 0 0", // #1B1B1B
  990: "17.76% 0 0", // #111111
});

export const sr25RedOklch = Object.freeze({
  20: "98.20% 0.009 26.02", // #FFF7F6
  50: "96.01% 0.020 21.36", // #FFEDEC
  100: "92.07% 0.040 23.55", // #FFDBD8
  150: "88.45% 0.061 23.37", // #FFCAC6
  200: "84.48% 0.085 25.25", // #FFB7B0
  300: "76.33% 0.141 25.05", // #FF8C84
  400: "68.30% 0.206 25.29", // #FF5653
  500: "59.70% 0.230 25.06", // #E91D2E
  600: "51.08% 0.207 25.02", // #C1001E
  700: "41.78% 0.169 25.08", // #930014
  800: "34.12% 0.138 25.22", // #6F000C
  900: "28.09% 0.114 25.09", // #540007
  950: "23.64% 0.096 25.25", // #410004
  980: "19.47% 0.079 25.65", // #300002
  990: "16.94% 0.068 23.90", // #260002
});

export const sr25AmberOklch = Object.freeze({
  20: "98.24% 0.013 71.33", // #FFF8F0
  50: "96.03% 0.028 69.17", // #FFEFDE
  100: "92.12% 0.059 70.29", // #FFDFBB
  150: "88.56% 0.089 71.17", // #FFD098
  200: "84.52% 0.123 70.58", // #FFBE6E
  300: "76.42% 0.165 70.66", // #F39D00
  400: "68.34% 0.147 71.05", // #D18700
  500: "59.81% 0.129 70.84", // #AF7000
  600: "50.98% 0.110 70.55", // #8D5900
  700: "41.73% 0.090 70.08", // #6B4200
  800: "34.07% 0.074 69.86", // #503000
  900: "28.18% 0.061 70.23", // #3C2300
  950: "23.50% 0.051 70.07", // #2D1900
  980: "19.57% 0.042 69.88", // #211100
  990: "16.93% 0.036 70.87", // #190C00
});

export const sr25GreenOklch = Object.freeze({
  20: "98.29% 0.013 145.47", // #F4FCF4
  50: "96.15% 0.028 148.61", // #E6F8E8
  100: "92.22% 0.059 148.80", // #CBF1D0
  150: "88.53% 0.095 148.85", // #ADEBB7
  200: "84.62% 0.123 148.40", // #92E39F
  300: "76.32% 0.165 148.38", // #5BCE74
  400: "68.24% 0.189 148.51", // #19B750
  500: "59.88% 0.171 148.51", // #009A3F
  600: "50.87% 0.145 148.56", // #007B31
  700: "41.74% 0.119 148.50", // #005D23
  800: "34.07% 0.097 148.49", // #004518
  900: "28.02% 0.080 148.62", // #003310
  950: "23.44% 0.067 148.62", // #00260A
  980: "19.76% 0.056 148.63", // #001C06
  990: "17.09% 0.048 148.85", // #001504
});

export const sr25TealOklch = Object.freeze({
  20: "98.16% 0.013 185.10", // #F0FCFA
  50: "96.09% 0.029 180.83", // #DEF9F3
  100: "92.22% 0.060 181.78", // #BAF3E8
  150: "88.53% 0.095 183.03", // #8DEEDF
  200: "84.45% 0.122 182.05", // #5DE6D2
  300: "76.40% 0.137 182.11", // #00CEB9
  400: "68.24% 0.122 182.26", // #00B19F
  500: "59.82% 0.107 182.47", // #009485
  600: "50.76% 0.091 181.73", // #007669
  700: "41.63% 0.075 181.91", // #00594F
  800: "34.00% 0.061 181.54", // #00423A
  900: "28.10% 0.050 182.14", // #00312B
  950: "23.35% 0.042 181.54", // #00241F
  980: "19.93% 0.036 181.85", // #001B17
  990: "17.17% 0.031 183.03", // #001411
});

export const sr25BlueOklch = Object.freeze({
  20: "98.28% 0.009 247.91", // #F5FAFF
  50: "96.09% 0.019 255.53", // #EAF3FF
  100: "92.13% 0.039 254.29", // #D4E7FF
  150: "88.47% 0.058 253.27", // #BFDCFF
  200: "84.53% 0.079 252.77", // #A8D0FF
  300: "76.33% 0.124 252.99", // #77B6FF
  400: "68.27% 0.171 253.07", // #3E9BFF
  500: "59.75% 0.185 253.10", // #007FE9
  600: "51.10% 0.158 253.05", // #0066BD
  700: "41.75% 0.130 253.19", // #004C90
  800: "34.10% 0.104 253.10", // #01386C
  900: "28.11% 0.087 252.93", // #002952
  950: "23.53% 0.073 253.05", // #001E3F
  980: "19.58% 0.060 252.86", // #00152F
  990: "16.89% 0.052 253.26", // #000F25
});

export const sr25PurpleOklch = Object.freeze({
  20: "98.26% 0.009 299.24", // #FAF8FF
  50: "95.99% 0.022 297.42", // #F3EFFF
  100: "92.17% 0.042 295.90", // #E7E0FF
  150: "88.62% 0.062 295.29", // #DCD2FF
  200: "84.51% 0.087 296.33", // #D1C1FF
  300: "76.42% 0.137 296.44", // #BB9FFF
  400: "68.41% 0.189 296.05", // #A67BFF
  500: "59.85% 0.196 295.97", // #8D5EE5
  600: "50.92% 0.196 296.34", // #7441C6
  700: "41.69% 0.196 296.43", // #5B20A7
  800: "34.07% 0.186 296.11", // #46008A
  900: "28.05% 0.153 296.28", // #340069
  950: "23.47% 0.128 296.57", // #270051
  980: "19.85% 0.108 296.62", // #1D003F
  990: "17.01% 0.093 295.61", // #150032
});

export const sr25VioletOklch = Object.freeze({
  20: "98.39% 0.009 314.78", // #FCF8FE
  50: "96.02% 0.021 313.83", // #F7EEFC
  100: "92.10% 0.054 313.46", // #F2DBFF
  150: "88.54% 0.081 314.13", // #EDCAFF
  200: "84.51% 0.110 313.61", // #E6B7FF
  300: "76.38% 0.175 313.99", // #DA8DFF
  400: "68.30% 0.242 313.78", // #CD5CFF
  500: "59.87% 0.266 313.77", // #B62EEB
  600: "50.94% 0.252 313.86", // #9700C7
  700: "41.79% 0.207 314.03", // #730098
  800: "34.12% 0.169 313.90", // #560073
  900: "28.00% 0.139 313.69", // #400057
  950: "23.55% 0.117 314.08", // #310043
  980: "19.93% 0.099 313.72", // #250034
  990: "17.03% 0.084 314.09", // #1C0028
});

export const sr25PinkOklch = Object.freeze({
  20: "98.26% 0.009 8.54", // #FFF7F8
  50: "95.93% 0.021 3.08", // #FFECF0
  100: "92.12% 0.042 5.11", // #FFDAE1
  150: "88.61% 0.063 6.02", // #FFC9D3
  200: "84.47% 0.089 5.11", // #FFB4C4
  300: "76.34% 0.148 5.82", // #FF87A4
  400: "68.33% 0.217 5.87", // #FF4C85
  500: "59.81% 0.240 5.83", // #E8006A
  600: "50.88% 0.204 5.85", // #BB0054
  700: "41.77% 0.168 5.61", // #8F003F
  800: "34.14% 0.137 5.50", // #6C002E
  900: "27.96% 0.112 5.25", // #510021
  950: "23.64% 0.095 5.35", // #3F0018
  980: "19.85% 0.080 6.15", // #300010
  990: "17.00% 0.068 5.62", // #25000B
});
